/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HSExamWorkingRestrictionDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: HSExamWorkingRestrictionDefinitionDto.source;
    opinion?: string;
    label?: string;
}

export namespace HSExamWorkingRestrictionDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
